import script from "./MintAsset.vue?vue&type=script&setup=true&lang=js"
export * from "./MintAsset.vue?vue&type=script&setup=true&lang=js"

import "./MintAsset.vue?vue&type=style&index=0&id=18a23a24&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18a23a24"]])

export default __exports__